import { ExpoRoot, type RequireContext } from 'expo-router';

import { useIsExpoRouterEnabled } from '@order/shared/hooks';

import { AppNavigation } from './navigation/AppNavigation';

// ─────────────────────────────────────────────────────────────────────────────

export const AppRouter = () => {
  const isExpoRouterEnabled = useIsExpoRouterEnabled();

  return isExpoRouterEnabled ? (
    <ExpoRoot context={expoRouterContext} />
  ) : (
    <AppNavigation />
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

// Expo Router file-based routing context.
const expoRouterContext = (require as MetroRequire).context('./app');

// ─── Types ───────────────────────────────────────────────────────────────────

// NOTE: Metro provides `require.context`; `NodeJS.Require` type doesn't include it.
type MetroRequire = NodeJS.Require & {
  context: (path: string) => RequireContext;
};
